import { render } from "./DoubleVerify.vue?vue&type=template&id=6484983d&scoped=true"
import script from "./DoubleVerify.vue?vue&type=script&lang=js"
export * from "./DoubleVerify.vue?vue&type=script&lang=js"

import "./DoubleVerify.vue?vue&type=style&index=0&id=6484983d&scoped=true&lang=css"

import exportComponent from "/Users/jamest/local_sites/EliteInsights/wp.eliteinsights.com/html/wp-content/plugins/wp-opinion-custom-voting-page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6484983d"]])

export default __exports__